import { useState } from 'react';
import { toast } from 'react-toastify';
import fleetApi from '../../services/api.service';

const usePostAssignSteps = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(null);
  const [data, setData] = useState(null);

  const assignSteps = async (assignStepsParams) => {
    resetStates();
    try {
      setIsLoading(true);
      const response = await fleetApi.post('/tours-planning/steps/assign', {
        tour_planning_ids: assignStepsParams.tour_planning_ids,
        vehicle_key: assignStepsParams.vehicle_key,
        tour_date: assignStepsParams.tour_date,
      });

      if (response.status === 200) {
        setIsSuccess(true);
        setData(response.data);
        return response.data;
      } else {
        throw new Error(response.data?.message || 'Une erreur est survenue.');
      }
    } catch (error) {
      setIsSuccess(false);
      toast.error(
        error?.response?.data?.message ||
          error?.message ||
          "Erreur lors de l'affectation des étapes"
      );
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  const resetStates = () => {
    setIsSuccess(false);
    setIsLoading(false);
    setData(null);
  };

  return {
    isLoading,
    isSuccess,
    data,
    assignSteps,
  };
};

export default usePostAssignSteps;

